// UI availability only: preserve Meta APIs, records and credentials for later.
export const META_MODULE_ENABLED = false;
